var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-file-input',{attrs:{"dense":"","outlined":"","label":"upload file"},on:{"change":_vm.add},model:{value:(_vm.file),callback:function ($$v) {_vm.file=$$v},expression:"file"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }